import { props as providerProps } from "./provider-props.js";
import { props as eventsProps } from "./events-props.js";

export const KINDS = Object.freeze(["provider", "events"]);

export const PROVIDER_PROP_NAMES = Object.freeze(Object.keys(providerProps));

export const EVENTS_PROP_NAMES = Object.freeze(Object.keys(eventsProps));

/**
 * The provider props apply to `kind="provider"`, the events props to `kind="events"`. A prop that
 * does not apply to the resolved kind is ignored.
 */
export const props = Object.freeze({
  /**
   * The domain the search box serves: `provider` (doctor and location finders) or `events`. When
   * absent, the `kind` of the enclosing `sp-finder` applies, else `provider`. Read once on mount.
   *
   * @type {String}
   * @default undefined
   */
  kind: {
    type: String,
    default: undefined,
    validator: (value) => KINDS.includes(value),
  },
  ...providerProps,
  ...eventsProps,
  /**
   * Endpoint URL for the events autocomplete data. Required for `kind="events"`.
   *
   * @type {String}
   * @default undefined
   */
  src: {
    type: String,
    default: undefined,
  },
});
